// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileCharts_wrapper__iLLt2"};